<script lang="ts">
	import { page } from '$app/stores';
	import SiteHeader from '@shared/SiteHeader.svelte';

	const site = $derived($page.data.site);
</script>

<SiteHeader {site} context="blog" />
